import { defineMessages } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import type { ProfileProps } from '@atlaskit/atlassian-navigation/profile/types';
import type { Profile as ProfileNav4 } from '@atlaskit/navigation-system/top-nav-items/profile';
import type { TriggerProps } from '@atlaskit/popup/types';

export type AccountMenuTriggerProps = Pick<ProfileProps, 'onClick' | 'testId'> &
	TriggerProps & {
		email: string | undefined;
		picture: string | undefined;
		trustPicture?: boolean;
	};

/**
 * `@atlaskit/navigation-system` does not export the props type for its `Profile` component,
 * so it is derived from the component itself.
 */
type ProfilePropsNav4 = React.ComponentPropsWithoutRef<typeof ProfileNav4>;

export type AccountMenuTriggerPropsNav4 = Pick<ProfilePropsNav4, 'onClick' | 'testId'> &
	TriggerProps & {
		email: string | undefined;
		picture: string | undefined;
		trustPicture?: boolean;
	};

export const messages: {
	popupLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	triggerTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	triggerTooltip: {
		id: 'identity.account-menu.account-menu-popup.skeleton.tooltip',
		defaultMessage: 'Account',
		description: 'Tooltip and alt-text for the account menu item',
	},
	popupLabel: {
		id: 'identity.account-menu.account-menu-popup.popup-label',
		defaultMessage: 'Account details',
		description:
			'Accessible name for the non-modal dialog that opens from the account (profile) button in the top navigation',
	},
});
